import type { Course, DashboardResponse, User } from "@nelurio/contracts";

const iso = (offsetDays = 0) => {
  const date = new Date();
  date.setDate(date.getDate() + offsetDays);
  return date.toISOString().slice(0, 10);
};

export const demoUser: User = {
  id: "demo-user",
  email: "student@nelurio.test",
  displayName: "Anna",
  interfaceLocale: "de-DE",
  nativeLanguage: "fa",
  studyLanguage: "de",
  timezone: "Europe/Berlin",
  plan: "free"
};

export const demoCourses: Course[] = [
  { id: "course-math", title: "Engineering Mathematics", code: "MATH-204", color: "#6c4cf6", icon: "∑", professor: "Dr. Weber", examDate: iso(21), progress: 68, active: true, resourceCount: 12, dueReviewCount: 2 },
  { id: "course-history", title: "European History", code: "HIST-110", color: "#ff6863", icon: "⌛", professor: "Prof. Bauer", examDate: iso(34), progress: 43, active: true, resourceCount: 8, dueReviewCount: 1 },
  { id: "course-economics", title: "Microeconomics", code: "ECON-101", color: "#4dbd74", icon: "↗", professor: "Dr. Klein", examDate: iso(45), progress: 57, active: true, resourceCount: 10, dueReviewCount: 2 }
];

export const demoDashboard: DashboardResponse = {
  user: demoUser,
  summary: {
    scheduledCount: 3,
    anytimeCount: 2,
    dueReviews: 5,
    openTasks: 4,
    nextExam: { title: "Engineering Mathematics", date: iso(21), daysLeft: 21 }
  },
  courses: demoCourses,
  scheduled: [
    { id: "t1", courseId: "course-math", courseTitle: "Engineering Mathematics", title: "Review matrices", kind: "study", status: "open", dueDate: iso(), dueTime: "10:00", durationMinutes: 30, priority: "normal", tags: ["review:2"] },
    { id: "t2", courseId: "course-history", courseTitle: "European History", title: "New lesson: Industrial Revolution", kind: "new_lesson", status: "open", dueDate: iso(), dueTime: "14:30", durationMinutes: 35, priority: "normal", tags: ["new_lesson", "review:0"] },
    { id: "t3", courseId: "course-history", courseTitle: "European History", title: "Chapter 2 practice exam", kind: "exam", status: "open", dueDate: iso(), dueTime: "17:00", durationMinutes: 20, priority: "high", tags: ["exam"] }
  ],
  anytime: [
    { id: "t4", courseId: "course-economics", courseTitle: "Microeconomics", title: "Finish exercise set 3", kind: "assignment", status: "open", dueDate: iso(), dueTime: null, durationMinutes: 45, priority: "normal", tags: ["assignment"] },
    { id: "t5", courseId: "course-economics", courseTitle: "Microeconomics", title: "Review market concepts", kind: "study", status: "open", dueDate: iso(), dueTime: null, durationMinutes: 25, priority: "normal", tags: ["review:3"] }
  ],
  reviews: [
    { id: "r1", courseId: "course-math", courseTitle: "Engineering Mathematics", title: "Matrices", stage: 2, offsetDays: 3, dueDate: iso() },
    { id: "r2", courseId: "course-history", courseTitle: "European History", title: "Industrial Revolution", stage: 0, offsetDays: 0, dueDate: iso() }
  ],
  calendar: [
    { id: "c1", date: iso(), time: "10:00", title: "Matrices", type: "review", courseTitle: "Engineering Mathematics", reviewStage: 2 },
    { id: "c2", date: iso(), time: "14:30", title: "Industrial Revolution", type: "new_lesson", courseTitle: "European History" },
    { id: "c3", date: iso(2), time: null, title: "Exercise set 3", type: "assignment", courseTitle: "Microeconomics" },
    { id: "c4", date: iso(5), time: "09:00", title: "Chapter exam", type: "exam", courseTitle: "European History" },
    { id: "c5", date: iso(7), time: null, title: "Matrices review", type: "review", courseTitle: "Engineering Mathematics", reviewStage: 3 }
  ]
};
